let config = {a:10, b:20};
const {a} = config;